import {Action} from "redux";
import {IClientClientBookmarksActionCreator} from "../action/client_client_bookmarks_action";
import {GetAllClientBookmarkByClientRequest} from "../request/client_bookmark_request";

interface IClientClientBookmarksDispatcher {
    getAllClientBookmarks(item: GetAllClientBookmarkByClientRequest): void;
}

class Dispatcher implements IClientClientBookmarksDispatcher {

    constructor(private dispatch: (action: Action) => void,
                private actionCreator: IClientClientBookmarksActionCreator) {

    }

    public getAllClientBookmarks = (item: GetAllClientBookmarkByClientRequest): void => {
        this.dispatch(this.actionCreator.requestGetAllClientBookmarksAction(item));
    }

}

const createClientClientBookmarksDispatcher = (dispatch: (action: Action) => void, actionCreator: IClientClientBookmarksActionCreator): IClientClientBookmarksDispatcher => {
    return new Dispatcher(dispatch, actionCreator);
};

export {IClientClientBookmarksDispatcher, createClientClientBookmarksDispatcher};



// WEBPACK FOOTER //
// ./src/presentation/dispatcher/client_client_bookmarks_dispatcher.ts